const DEFAULT_ACCOUNT_BASE_URL = "https://account-ms.test.hanypay.co";
const DEFAULT_PAYMENT_BASE_URL = "https://payment-ms.test.hanypay.co";
const DEFAULT_WALLET_BASE_URL = "https://wallet-ms.test.hanypay.co";

function normalizeBaseUrl(value: string | undefined, fallback: string) {
  const cleanedValue = value?.trim().replace(/^["']|["']$/g, "");

  if (
    !cleanedValue ||
    cleanedValue === "BASE_SERVER_URL" ||
    cleanedValue === "undefined" ||
    cleanedValue === "null" ||
    cleanedValue.startsWith("/")
  ) {
    return fallback;
  }

  if (/^https?:\/\//i.test(cleanedValue)) {
    return cleanedValue.replace(/\/+$/, "");
  }

  return `https://${cleanedValue.replace(/\/+$/, "")}`;
}

export const REACT_APP_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_BASE_URL, DEFAULT_ACCOUNT_BASE_URL);
export const REACT_APP_WALLET_URL = normalizeBaseUrl(
  process.env.REACT_APP_WALLET_URL,
  DEFAULT_WALLET_BASE_URL,
);
export const REACT_APP_PAYMENT_URL = normalizeBaseUrl(process.env.REACT_APP_PAYMENT_URL, DEFAULT_PAYMENT_BASE_URL);
export const REACT_APP_PAYMENT_KEY = process.env.REACT_APP_PAYMENT_KEY;
export const REACT_APP_WALLET_KEY = process.env.REACT_APP_WALLET_KEY;
export const REACT_APP_API_KEY = process.env.REACT_APP_API_KEY;
export const REACT_APP_KENYA_PHONE = process.env.REACT_APP_KENYA_PHONE;

export enum NAV_ITEMS {
  DASHBOARD = "Dashboard",
  WALLETS = "Wallets",
  HISTORY = "History",
  MARKETPLACE = "Hanymarket",
  BUSINESS = "Business",
  TRADING = "Trading",
  BUSINESS_TRADING = "Business trade",
  STATEMENTS = "Statements",
  ACCOUNT = "Account",
}

export const currencies = [
  { label: "AKL Lumi", value: "AKL" },
  { label: "US Dollar", value: "USD" },
  { label: "Euro", value: "EUR" },
  { label: "British Pound", value: "GBP" },
  { label: "Japanese Yen", value: "JPY" },
  { label: "South African Rand", value: "ZAR" },
  { label: "Nigerian Naira", value: "NGN" },
  { label: "Kenyan Shilling", value: "KES" },
  { label: "Ghanaian Cedi", value: "GHS" },
];

export const wallets = [
  { label: "Visa card / Credit card", value: "card" },
  { label: "Mobile money", value: "mobile-money" },
  { label: "Lumi card", value: "lumi-card" },
];

export const Statuses = [
  { label: "Pending", value: "pending" },
  { label: "Completed", value: "completed" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Failed", value: "failed" },
  { label: "All", value: "all" },
];

export const TransactionTypes = [
  { label: "Transfer", value: "Transfer" },
  { label: "Purchase", value: "Purchase" },
  { label: "Refund", value: "Refund" },
  { label: "Charge back", value: "Chargeback" },
];
